import configPOPTheme from '@/config/POPTheme'

export const dayBrance = day => {
    switch ( String(day) ) {
        case 'monday':
        return 'จ.'
        case 'tuesday':
        return 'อ.'
        case 'wednesday':
        return 'พ.'
        case 'thursday':
        return 'พฤ.'
        case 'friday':
        return 'ศ.'
        case 'saturday':
        return 'ส.'
        case 'sunday':
        return 'อา.'
        case 'holidays':
        return 'วันหยุดนักขัตฤกษ์'
        default:
        return '-'
    }
};

export const locationBrance = place => {
    switch ( String(place) ) {
        case 'dorm':
        return 'ตลาด'
        case 'village':
        return 'หมู่บ้าน'
        case 'market':
        return 'ตลาด'
        case 'condo':
        return 'คอนโด'
        case 'building':
        return 'อาคารพาณิชย์'
        case 'road':
        return 'ติดถนนใหญ่'
        case 'gas':
        return 'ปั๊มน้ำมัน.'
        case 'mall':
        return 'ในห้างสรรพสินค้า'
        case 'other':
        return ''
        default:
        return '-'
    }
};

export const serviceAreaBrance = area => {
    switch ( String(area) ) {
        case '0.50':
        return '500 เมตร'
        case '1.00':
        return '1 กิโลเมตร'
        case '2.00':
        return '2 กิโลเมตร'
        case '3.00':
        return '3 กิโลเมตร'
        case '5.00':
        return '5 กิโลเมตร'
        default:
        return '-'
    }
}

export const heightBrance = meter => {
    switch ( String(meter) ) {
        case '2.00':
        return '2 เมตร'
        case '2.50':
        return '2.5 เมตร'
        case '3.00':
        return '3 เมตร'
        case '4.00':
        return '3 เมตรขึ้นไป'
        default:
        return '-'
    }
}

export const rentBrance = rent => {
    switch ( String(rent) ) {
        case 'YES':
        return 'มี สะดวกให้เช่าพื้นที่ได้'
        case 'HOWEVER':
        return 'มี แต่ไม่สะดวกให้เช่าพื้นที่'
        case 'NO':
        return 'ไม่มีพื้นที่ว่าง'
        default:
        return '-'
    }
}

export const billboardBrance = billboard => {
    switch ( String(billboard) ) {
        case 'YES':
        return 'มี สะดวกให้เช่าพื้นที่สำหรับติดป้ายโฆษณา'
        case 'HOWEVER':
        return 'มี แต่ไม่สะดวกให้เช่าพื้นที่สำหรับติดป้ายโฆษณา'
        case 'NO':
        return 'ไม่มีพื้นที่'
        default:
        return '-'
    }
}

export const kitchenBrance = kitchen => {
    switch ( String(kitchen) ) {
        case 'YES':
        return 'มี สะดวกให้เช่าพื้นที่ และมีพื้นที่สำหรับล้างอุปกรณ์'
        case 'HOWEVER':
        return 'มี แต่ไม่สะดวกให้เช่าพื้นที่ และไม่มีพื้นที่สำหรับล้างอุปกรณ์'
        case 'NO':
        return 'ไม่มีพื้นที่ทำครัว'
        default:
        return '-'
    }
}

export const sellServiceBrance = sell => {
    switch ( String(sell) ) {
        case 'YES':
        return `สนใจ ยินดีเปิดทุกบริการที่ ${configPOPTheme.webTitle} SHOP มี`
        case 'HOWEVER':
        return 'สนใจ ยินดีเปิดบางบริการ ขอพิจารณาก่อน'
        case 'NO':
        return 'ไม่สนใจ'
        default:
        return '-'
    }
}

export const otherServiceBrance = other => {
    switch ( String(other) ) {
        case 'YES':
        return `สนใจ ทาง ${configPOPTheme.webTitle} จะติดต่อกลับ`
        case 'NO':
        return `ไม่สนใจ ทาง ${configPOPTheme.webTitle} จะไม่ติดต่อเพื่อรบกวนคุณ`
        default:
        return '-'
    }
}

export const operatingSystemBrance = system => {
    switch ( String(system) ) {
        case 'android':
        return 'Android'
        case 'ios':
        return 'IOS'
        case 'androidIos':
        return 'ทั้ง Android และ IOS.'
        case 'other':
        return ''
        default:
        return '-'
    }
}

export const typeCarTHPBrance = typeCar => {
    switch ( String(typeCar) ) {
        case 'TRUCK':
        return 'รถใหญ่'
        case 'MOTORCYCLE':
        return 'รถเล็ก'
        default:
        return '-'
    }
}

export const paymentTypeCondition = condition => {
    switch ( String(condition) ) {
        case ('TMR' || 'TUE'):
        return '1'
        case ('MON'):
        return '0'
        case 'WEEK':
        return '6'
        case 'WED':
        return '2'
        case 'THU':
        return '3'
        case 'FRI':
        return '4'
        default:
        return null
    }
}